// Copyright (c) 2025 Deere & Company

import t from 'tcomb';

const DuplicatePinPlateSearchRequest = t.struct({
    pins: t.Any,
    dealerAccounts: t.Any,
    requesterTCSMs: t.Any,
    factoryCodes: t.Any,
    status: t.Any,
    fromDateSubmmited: t.Any,
    toDateSubmmited: t.Any,
    fromUpdatedTs: t.Any,
    toUpdatedTs: t.Any,

}, {
    name: 'DuplicatePinPlateSearchRequest',
    strict: false,
});

export const getDefaultState = () => new DuplicatePinPlateSearchRequest({
    pins: null,
    dealerAccounts: null,
    requesterTCSMs: null,
    factoryCodes: null,
    status: null,
    fromDateSubmmited: null,
    toDateSubmmited: null,
    fromUpdatedTs: null,
    toUpdatedTs: null,
});

export default DuplicatePinPlateSearchRequest;
